export default __webpack_public_path__ + "static/media/codex_button_up_release.b98df874.jpg";